import { WebPlugin } from '@capacitor/core';
export class LpapiPluginWeb extends WebPlugin {
    async getPrinterState() {
        return Promise.resolve();
    }
    async printText1DBarcode(options) {
        return options;
    }
    async printText(options) {
        return options;
    }
    async drawText1DBarcode(options) {
        return options;
    }
    async drawText(options) {
        return options;
    }
    async drawCircle(options) {
        return options;
    }
    async drawRect(options) {
        return options;
    }
    async drawLine(options) {
        return options;
    }
    async startJob(options) {
        return options;
    }
    async abortJob() {
        return Promise.resolve();
        ;
    }
    async commitJob() {
        return Promise.resolve();
        ;
    }
    async disconnectPrinter() {
        return Promise.resolve();
    }
    async connectPrinter(options) {
        return options;
    }
    async getPairedPrinters() {
        return Promise.resolve();
    }
}
//# sourceMappingURL=web.js.map